module.exports = __webpack_public_path__ + "img/logo-college-mathieu.fd61148e.jpg";